import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useTenantUserQuery(userId: string | undefined) {
  const { user } = useAuth();

  return useQuery({
    queryKey: tenantQueryKeys.user(userId ?? ''),
    enabled: Boolean(user) && Boolean(userId),
    queryFn: () => {
      if (!userId) {
        throw new Error('Missing user id');
      }
      return userService.getUser(userId);
    },
  });
}
